/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export default class blockDomActionsHelper {
	static bloquerClicks(): void {
		if (document.getElementById("global-overlay")) {
			return;
		}
		const overlay = document.createElement("div");
		overlay.id = "global-overlay";
		overlay.style.position = "fixed";
		overlay.style.top = "0";
		overlay.style.left = "0";
		overlay.style.width = "100vw";
		overlay.style.height = "100vh";
		overlay.style.zIndex = "9999";
		overlay.style.background = "rgba(0,0,0,0)";
		overlay.style.cursor = "not-allowed";
		overlay.addEventListener("click", (e) => e.stopPropagation(), true);
		document.body.appendChild(overlay);
	}

	static debloquerClicks(): void {
		const overlay = document.getElementById("global-overlay");
		if (overlay) {
			overlay.remove();
		}
	}
}



// WEBPACK FOOTER //
// ./src/Helper/blockDomActionsHelper.ts